import React, { Component } from "react"
import Svg from "../../../../_svgs/svg"
import DatePickerPikaday from "../../../../../styleguide/js/components/datepicker-pikaday"

class DatePickerForm extends Component {
  constructor(props) {
    super(props)
    this.datePickerFrom = undefined
    this.datePickerTo = undefined
    this.dateTextBoxFromRef = React.createRef()
    this.dateTextBoxToRef = React.createRef()
    this.state = {
      fromDate: "",
      toDate: "",
    }
  }

  componentDidMount() {
    if (this.dateTextBoxFromRef.current && !this.datePickerFrom) {
      this.datePickerFrom = new DatePickerPikaday({ el: this.dateTextBoxFromRef.current })
      this.setDateInDatePicker = this.datePickerFrom.getPicker().setDate
    }

    if (this.dateTextBoxToRef.current && !this.datePickerTo) {
      this.datePickerTo = new DatePickerPikaday({ el: this.dateTextBoxToRef.current })
      this.setDateInDatePicker = this.datePickerTo.getPicker().setDate
    }
  }

  componentDidUpdate() {
    this.datePickerFrom.getPicker().destroy()
    delete this.datePickerFrom
    this.dateTextBoxFromRef.current.classList.remove("is-bound") // forces datepicker re-initialization
    this.datePickerFrom = new DatePickerPikaday({ el: this.dateTextBoxFromRef.current })

    this.datePickerTo.getPicker().destroy()
    delete this.datePickerTo
    this.dateTextBoxToRef.current.classList.remove("is-bound") // forces datepicker re-initialization
    this.datePickerTo = new DatePickerPikaday({ el: this.dateTextBoxToRef.current })
  }

  handleInput = (event) => {
    const name = event.target.name
    const value = event.target.value
    this.setState({ [name]: value })
  }

  render() {
    //#region Default date vars
    const now = new Date()
    const minDay = now.getDate()
    const minMonth = now.getMonth() + 1
    const minYear = now.getFullYear() - 2000
    //#endregion

    return (
      <div className="form">
        <div className="form__section form__section--light form__section--short booking-form-datepicker">
          <div
            ref={this.dateTextBoxFromRef}
            className="form__field form__field--date form__field--short form__field--date--pikaday rm-this-class-hide-default booking-date-from"
          >
            <input
              className={`form__item ${this.props.sourceTable}--from`}
              min={this.props.minDateToday ? `${minDay} / ${minMonth} / ${minYear}` : ""}
              name="fromDate"
              readOnly={true}
              type="text"
              value={this.state.fromDate}
              onBlur={(e) => this.handleInput(e)}
            />
            <label className="form__label">
              <span className="form__label__text">
                {this.props.bookingDatePickerFrom}&nbsp;&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
          </div>

          <div
            ref={this.dateTextBoxToRef}
            className="form__field form__field--date form__field--short form__field--date--pikaday rm-this-class-hide-default booking-date-to"
          >
            <input
              className={`form__item ${this.props.sourceTable}--to`}
              min={this.state.fromDate ? this.state.fromDate : ""}
              name="toDate"
              readOnly={true}
              type="text"
              value={this.state.toDate}
              onBlur={(e) => this.handleInput(e)}
            />
            <label className="form__label">
              <span className="form__label__text">
                {this.props.bookingDatePickerTo}&nbsp;&nbsp;<strong>&nbsp;</strong>
              </span>
            </label>
          </div>
          <button
            className="button button--medium button--general rm-this-class rm-this-class-hide-default booking-form-button"
            onClick={() => this.props.changeDateState(this.state.fromDate, this.state.toDate)}
          >
            <span className="icon">
              <Svg iconName={"svg-planeduo"} />
            </span>
            <span className="text">{this.props.datepickerButtonText || "Hent"}</span>
          </button>
        </div>
      </div>
    )
  }
}

export default DatePickerForm
